import { render, staticRenderFns } from "./assuredBook.vue?vue&type=template&id=13534216&scoped=true"
import script from "./assuredBook.vue?vue&type=script&lang=js"
export * from "./assuredBook.vue?vue&type=script&lang=js"
import style0 from "./assuredBook.vue?vue&type=style&index=0&id=13534216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13534216",
  null
  
)

export default component.exports